import { ElementRef, Input, Directive } from '@angular/core';
import { TableRowColor } from 'yt-ng-framework';

@Directive({
    selector: '[rowColor]'
})
export class RowColorDirective {
    constructor(private el: ElementRef){

    }

    @Input() rowColorItem: any;
    @Input() rowColors: TableRowColor[];

    ngOnInit(){
        if(this.rowColorItem != null && this.rowColors != null && this.rowColors.length > 0){
            this.rowColors.forEach(rowColor => {
                let color = this.getColor(rowColor);
                if(color != '#ffffff')
                    this.el.nativeElement.style.backgroundColor = color;
            })
        }
    }

    private getColor(rowColor: TableRowColor){
        let color: string = '#ffffff';
        if(this.rowColorItem[rowColor.ColumnName] == null)
            return color;
        
        switch(rowColor.Condition){
            case 'greaterThan': {
                if(this.rowColorItem[rowColor.ColumnName] > rowColor.Value) {
                    color = rowColor.Color;
                    
                }
                break;
            }
            case 'lessThan': {
                if(this.rowColorItem[rowColor.ColumnName] < rowColor.Value) {
                    color = rowColor.Color;
                    
                }
                break;
            }
            case 'equals': {
                if(this.rowColorItem[rowColor.ColumnName] == rowColor.Value) {
                    color = rowColor.Color;
                    
                }
                break;
            }
        }

        return color;
    }
}